<template>
    <div id="contenedor-main-proyectos-calendario">
        CALENDARIO
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
